class Import

	#import SnapGene
	
	#import Genious